export const GraphDummyData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
        {
            label: "Average Score",
            data: [40, 40, 40,40, 40, 40, 40, 40, 40, 40, 40, 40],
            fill: true,
            backgroundColor: "#F7590020",
            borderColor: "#F75900",
            borderCapStyle: 'round',
            borderDash: [10,5],
            tension: 0.2
        },
        {
            label: "Score",
            data: [43, 42, 44,43, 45, 44, 46, 45, 47, 36, 28, 47],
            fill: true,
            borderColor: "#883100",
            backgroundColor: "#88310010",
            tension: 0.2
        }
    ]
};

export default GraphDummyData;